import { Tabs, TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { DashboardProjectsPeriod, DashboardTabs } from 'enums/project.enum';
import ProjectTable from './project-table';
import PeopleTable from './people-table';
import BookingTable from './booking-table';
import { DashboardUserTables } from 'enums/dashboard.enum';
import PLGoals from './pl-goals';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { plGoalsSelector } from './_redux/selectors';
import { useEffect, useMemo } from 'react';
import { getPlGoals } from './_redux/actions';
import plGoals from './pl-goals';
import SalPlanning from './sal-planning';
import AuthService from 'core/auth/auth.service';

const DashboardPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const plGoals = useAppSelector(plGoalsSelector);

  useEffect(() => {
    if (!plGoals) {
      dispatch(getPlGoals({ dashboardFilterObiettiviPlDto: {} }));
    }
  }, []);

  const dashboardTabs: TabsProps['items'] = useMemo(
    () => [
      // {
      //   key: DashboardTabs.PROJECTS_TABLE_CURRENT_YEAR,
      //   label: t('dashboard.tabs.current-year-projects'),
      //   children: (
      //     <ProjectTable period={DashboardProjectsPeriod.CURRENT_YEAR} key={DashboardProjectsPeriod.CURRENT_YEAR} />
      //   ),
      // },
      ...(AuthService.isPl()
        ? [
            {
              key: DashboardTabs.PROJECTS_TABLE,
              label: t('dashboard.tabs.projects'),
              children: <ProjectTable key={DashboardProjectsPeriod.ALL} />,
            },
          ]
        : []),
      {
        key: DashboardTabs.PEOPLE_TABLE,
        label: t('dashboard.tabs.resource-planning'),
        children: <PeopleTable />,
      },
      {
        key: DashboardTabs.UNDERBOOKING_TABLE,
        label: t('dashboard.tabs.underbooking'),
        children: <BookingTable table={DashboardUserTables.UNDERBOOKING} key={DashboardUserTables.UNDERBOOKING} />,
      },
      {
        key: DashboardTabs.OVERBOOKING_TABLE,
        label: t('dashboard.tabs.overbooking'),
        children: <BookingTable table={DashboardUserTables.OVERBOOKING} key={DashboardUserTables.OVERBOOKING} />,
      },
      // Tab Obiettivi PL nascosto
      // ...(plGoals?.budgetMargineProgettoTarget !== undefined && plGoals?.margineProgettoLow !== undefined
      //   ? [
      //       {
      //         key: DashboardTabs.PL_GOALS,
      //         label: t('dashboard.tabs.pl-goals'),
      //         children: <PLGoals />,
      //       },
      //     ]
      //   : []),
      {
        key: DashboardTabs.SAL_PLANNING,
        label: t('dashboard.tabs.sal-planning'),
        children: <SalPlanning />,
      },
    ],
    [plGoals]
  );

  return (
    <>
      <h4 className="text-gray-800 ">{t('common.dashboard')}</h4>
      <Tabs
        defaultActiveKey={AuthService.isPl() ? DashboardTabs.PROJECTS_TABLE : DashboardTabs.PEOPLE_TABLE}
        items={dashboardTabs}
      />
    </>
  );
};
export default DashboardPage;
